import { Button } from 'components/atoms';
import { useFormSave } from 'hooks/useFormSave';
import { t } from 'i18next';
import { useStoreState } from 'providers/StoreStateContext';
import { PiPencilSimpleLine, PiWarning, PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import ApplicationAnnouncementWrapper from '../wrapper/ApplicationAnnouncementWrapper';

const UnsavedFormApplicationAnnouncement = () => {
  const { announcementDisplay } = useFormSave();
  const navigate = useNavigate();
  const { clearForms, musicProductDigitalForm, trackForm, videoForm, artistForm } = useStoreState();

  if (!announcementDisplay) return <></>;

  const navigateToForm = <Form extends { id: string }>(form: Form, domain: string, tab: string) => {
    navigate(`/${domain}/${form.id.length ? `edit/${form.id}` : 'create'}/${tab}`);
  };

  const redirect = () => {
    if (musicProductDigitalForm) {
      return navigateToForm(musicProductDigitalForm, 'music-product-digital', 'tracks');
    }
    if (trackForm) {
      return navigateToForm(trackForm, 'track', 'file');
    }
    if (artistForm) {
      return navigateToForm(artistForm, 'artist', 'data');
    }
  };

  return (
    <ApplicationAnnouncementWrapper
      icon={<PiWarning />}
      description={t('announcement.unfinished-form')}
      action={
        <>
          <Button isClear onlyIcon onClick={() => clearForms()} size="compact">
            <Button.Icon icon={<PiX />} />
          </Button>
          <Button onlyIcon variant={BUTTON_VARIANT.background} onClick={redirect} size="compact">
            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
        </>
      }
    />
  );
};

export default UnsavedFormApplicationAnnouncement;
